import {Card, CardContent} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    background: 'linear-gradient(270deg, #3457F2 0%, #B139D8 100%)',
    color: 'white',
    margin: '0 0 80px',
    borderRadius: '20px',
    paddingBottom: '10px',
    position: 'relative',
  },
  ContentBox: {
    backgroundColor: 'rgba(33, 35, 40, 1)',
  },
  titlebox: {
    fontFamily: 'Gilroy-Regular, sans-serif',
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '30px',
    color: '#fff',
    padding: '25px',
  },

}));

export const AuthenticityNotice = () => {
  const classes = useStyles();
    return(
      <Grid item xs={12} >
        <Card className={classes.card}>
          <CardContent className={classes.ContentBox}>
            <Typography variant="body2" color="textSecondary" component="p" className={classes.titlebox}>
              All NFTs have been minted by the colearn pAInt address:
              0xC73Bb3F183fbeAdC23bCB70460006c30Fc4c689A.
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    )
}